import { useCallback } from 'react'
import styled from 'styled-components'
import CruisePriceRoomTypeInfo from './CruisePriceRoomTypeInfo'
import OfferPageStickyFooter from 'components/OfferPage/OfferPageStickyFooter'
import { CruiseContentSections } from 'constants/cruise'
import Group from 'components/utils/Group'
import { isCruiseOnlyOfferView, type CruiseOfferView } from 'hooks/Cruise/useCruiseOfferView'
import CruiseStickyPrices from './CruiseStickyPrices'

const Footer = styled(OfferPageStickyFooter)`
  > div {
    align-items: flex-end;
  }
`

interface Props {
  view: CruiseOfferView
  onView: (ref: string) => void
  hasValidDepartures: boolean
  visible: boolean
}

function CruiseStickyFooter(props: Props) {
  const {
    view,
    onView,
    visible,
    hasValidDepartures,
  } = props

  const onCTAClick = useCallback(() => onView(CruiseContentSections.DEPARTURES), [onView])

  if (!isCruiseOnlyOfferView(view)) return null

  return (
    <Footer
      visible={visible}
      onCTAClick={onCTAClick}
      callToActionDisabled={!hasValidDepartures}
    >
      <Group direction="horizontal" verticalAlign="center" horizontalAlign="space-between" tabletGap={16}>
        {hasValidDepartures ? <CruiseStickyPrices
          view={view}
          hasValidDepartures={hasValidDepartures}
        /> : <CruisePriceRoomTypeInfo
          priceFrom={view.offer.mainDepartureDetails.lowestOverallPriceDetails}
          price={view.lowestPrice}
          memberPrice={view.memberLowestPrice}
          memberPriceType={view.memberPriceType}
          hasValidDepartures={hasValidDepartures}
        />}
      </Group>
    </Footer>
  )
}
export default CruiseStickyFooter
